import React, { useState } from "react";

interface CarouselProps {
  images: string[];
}

const Carousel: React.FC<CarouselProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="relative w-full max-w-md mx-auto flex items-center justify-center overflow-hidden">
      <div className="flex items-center justify-center relative">
        {/* Carousel Track */}
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {images.map((image, index) => {
            const isActive = index === currentIndex;
            const isAdjacent =
              index === (currentIndex + 1) % images.length ||
              index === (currentIndex - 1 + images.length) % images.length;

            return (
              <div
  key={index}
  className={`flex-shrink-0 transition-all duration-500 ease-in-out relative flex items-center justify-center ${
    isActive
      ? "scale-100 opacity-100 z-10"
      : isAdjacent
      ? "scale-75 opacity-50 z-5"
      : "scale-50 opacity-25 z-0"
  }`}
  style={{
    width: "100%",
  }}
>
  <div
    className={`w-11/12 mx-auto relative flex items-center justify-center ${
      isActive ? "z-20" : "z-10"
    }`}
  >
    <img
      src={image}
      alt={`Slide ${index + 1}`}
      className="max-h-full object-contain"
    />
  </div>
</div>
            );
          })}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={handlePrevious}
        className="absolute left-1 top-1/2 transform -translate-y-1/2 bg-red rounded-full text-white px-3 py-2 hover:bg-orange focus:outline-none z-30"
      >
        &#8592;
      </button>
      <button
        onClick={handleNext}
        className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-red rounded-full text-white px-3 py-2 hover:bg-orange focus:outline-none z-30"
      >
        &#8594;
      </button>
    </div>
  );
};

export default Carousel;
